import { USER_ROLE } from "../../Util/constants";
import FilterIcon from "../../assets/newIcn.png";
export const PAYMENT_STATUS_FILTER = [
  {
    id: 1,
    name: "All",
    value: "all",
    selected: true,
  },
  {
    id: 2,
    name: "Success",
    value: "success",
    selected: false,
  },
  {
    id: 3,
    name: "Pending",
    value: "pending",
    selected: false,
  },
  {
    id: 4,
    name: "Failed",
    value: "failed",
    selected: false,
  },
];

export const APPLICABLE_ROLE = {
  DOCTOR: "doctor",
  STAFF: "staff",
};

export const APPLICABLE_SUB_ROLE = {
  DOCTORADMIN: "Administrator",
  DOCTOR_CONSULTANT: "consultant",
};

export const PENDING_HEADER_LIST_TITLE = {
  DATETIME: "DATE & TIME",
  DOCTORNAME: "DOCTOR NAME",
  PATIENTDETAILS: "PATIENT DETAILS",
  PROCEDURE: "PROCEDURE",
  PAYMENTMETHOD: "PAYMENT METHOD",
  STATUS: "STATUS",
  ACTION: "ACTION",
};

export const PENDING_HEADER_LIST = [
  {
    id: 1,
    title: "DATE & TIME",
    mobileFilterTitle: "DATE & TIME",
    filter_type: "date",
    menuData: [],
    tempMenu: [],
    show_filter: false,
    dontShowOnMobile: true,
  },
  {
    id: 2,
    title: "DOCTOR NAME",
    mobileFilterTitle: "DOCTOR NAME",
    filter_type: "normal",
    menuData: [],
    tempMenu: [],
    filter_icon: FilterIcon,
    show_filter: false,
    show_search: true,
    dontShowOnMobile: false,
    showApplyResetBtn: true,
    isMultiSelect: true,
    show_filter_searchbar: true,
    applicable_roles: [
      USER_ROLE.DOCTOR_ADMIN,
      USER_ROLE.RESOURCE_ADMIN,
      APPLICABLE_ROLE.STAFF,
    ],
    placeholder: "Search for Doctor",
  },
  {
    id: 3,
    title: "PATIENT DETAILS",
    mobileFilterTitle: "PATIENT DETAILS",
    filter_type: "normal",
    menuData: [],
    tempMenu: [],
    show_filter: false,
    dontShowOnMobile: true,
  },
  {
    id: 4,
    title: "PROCEDURE",
    mobileFilterTitle: "PROCEDURE",
    filter_type: "normal",
    menuData: [],
    tempMenu: [],
    show_filter: false,
    dontShowOnMobile: true,
  },
  {
    id: 5,
    title: "PAYMENT METHOD",
    mobileFilterTitle: "PAYMENT METHOD",
    filter_type: "normal",
    menuData: [],
    tempMenu: [],
    show_filter: false,
    dontShowOnMobile: true,
  },
  {
    id: 6,
    title: "STATUS",
    mobileFilterTitle: "STATUS",
    filter_type: "normal",
    menuData: [...PAYMENT_STATUS_FILTER],
    tempMenu: [...PAYMENT_STATUS_FILTER],
    filter_icon: FilterIcon,
    show_filter: false,
    dontShowOnMobile: false,
  },
  {
    id: 7,
    title: "ACTION",
    mobileFilterTitle: "ACTION",
    filter_type: "normal",
    menuData: [],
    tempMenu: [],
    show_filter: false,
    dontShowOnMobile: true,
  },
];

export const HEADER_FILTER_TYPE = {
  NORMAL: "normal",
  DATE: "date",
  CONSULTATION: "consultation",
  DOCTORNAME: "doctorname",
};

export const MOBILE_FILTER_LIST = {
  DATE: "Date",
  DOCTOR_NAME: "Doctor Name",
  CONSULTATION: "Consultation",
  PAYMENT_METHOD: "Payment Method",
  PAYMENT_STATUS: "Payment Transferred Status",
};

export const FILTER_ICON_TYPE = {
  NORMAL: "normal",
  DATE: "date",
  CONSULTATION: "consultation",
};
export const API_FILTER_LIST = {
  DOCTORNAME: "doctor_ids",
  DOCTOR_NAME: "doctor_ids",
  PAGENO: "page_no",
  STATUS: "status_filter",
};

export const DEFAULT_PENDING_PAYLOAD = {
  page_no: 1,
  rows_per_page: 10,
  status_filter: "",
  doctor_id: [],
};

export const SELECTED_FILTER_TITLE = {
  DOCTORNAME: "Doctor Name",
  STATUS: "Status",
  CLEARALL: "Clear All Filter",
};

export const PENDING_STATUS = {
  SUCCESS: "success",
  PENDING: "pending",
  FAILED: "failed",
};
